// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import './_collection-list.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--collection-list';
var CAROUSEL_SECTION_SELECTOR = '.collection-list';
var CAROUSEL_SECTION_CLASS = 'collection-list';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
var DESKTOP_BREAKPOINT = 1080;
var MAX_COLLECTIONS_FOR_SWIPER = 4;

// -------------------------------------
// Helper Functions
// -------------------------------------
function updateArrowVisibility(swiper, prevButton, nextButton, pagination) {
  var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
  if (prevButton) {
    prevButton.style.display = isDesktop ? 'flex' : 'none';
  }
  if (nextButton) {
    nextButton.style.display = isDesktop ? 'flex' : 'none';
  }
  if (pagination) {
    pagination.style.display = isDesktop ? 'flex' : 'none';
  }
  if (!isDesktop || !prevButton || !nextButton) return;
  var setArrowState = (button, isDisabled) => {
    button.style.opacity = isDisabled ? '0.5' : '1';
    button.style.pointerEvents = isDisabled ? 'none' : 'auto';
  };
  setArrowState(prevButton, swiper.isBeginning);
  setArrowState(nextButton, swiper.isEnd);
}

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  var carousel = element.querySelector(CAROUSEL_SELECTOR);
  if (!carousel) return;
  var collectionCount = parseInt(element.getAttribute('data-collection-count') || '0', 10);
  if (collectionCount <= MAX_COLLECTIONS_FOR_SWIPER) {
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      var carouselWrapper = element.querySelector('.collection-list__carousel--desktop');
      if (carouselWrapper) {
        carouselWrapper.style.display = 'none';
      }
    }
    return;
  }
  var uniqueCarouselClass = "".concat(CAROUSEL_SELECTOR.substring(1), "-").concat(index);
  carousel.classList.add(uniqueCarouselClass);
  var prevButton = element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR);
  var nextButton = element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR);
  var pagination = element.querySelector(CAROUSEL_PAGINATION_SELECTOR);
  var uniqueClassSuffix = "-".concat(index);
  if (prevButton) {
    prevButton.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev").concat(uniqueClassSuffix));
  }
  if (nextButton) {
    nextButton.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next").concat(uniqueClassSuffix));
  }
  if (pagination) {
    pagination.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination").concat(uniqueClassSuffix));
  }
  var desktopSlidesPerView = Math.min(collectionCount, 4);
  var swiper = new Swiper(".".concat(uniqueCarouselClass), {
    modules: [Navigation, Pagination, Keyboard],
    slidesPerView: 1,
    spaceBetween: 12,
    loop: false,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    breakpoints: {
      [DESKTOP_BREAKPOINT]: {
        slidesPerView: desktopSlidesPerView,
        spaceBetween: 12
      }
    },
    navigation: {
      nextEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-next").concat(uniqueClassSuffix),
      prevEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-prev").concat(uniqueClassSuffix)
    },
    pagination: {
      el: ".".concat(CAROUSEL_SECTION_CLASS, "-pagination").concat(uniqueClassSuffix),
      type: 'bullets',
      clickable: true
    },
    on: {
      init: function init() {
        updateArrowVisibility(this, prevButton, nextButton, pagination);
      },
      slideChange: function slideChange() {
        updateArrowVisibility(this, prevButton, nextButton, pagination);
      },
      resize: function resize() {
        updateArrowVisibility(this, prevButton, nextButton, pagination);
      }
    }
  });
  swiper.slides.forEach((slide, slideIndex) => {
    var slideLink = slide.querySelector('a');
    if (slideLink) {
      slideLink.addEventListener('focus', () => {
        swiper.slideTo(slideIndex);
      });
    }
  });
  var syncArrowPosition = () => {
    var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    var arrows = [prevButton, nextButton].filter(Boolean);
    if (arrows.length === 2 && isDesktop) {
      var carouselContainer = element.querySelector('.collection-list__carousel--desktop');
      if (!carouselContainer) return;
      var swiperRect = carousel.getBoundingClientRect();
      var containerRect = carouselContainer.getBoundingClientRect();
      if (swiperRect.height === 0) return;
      var swiperCenterRelative = swiperRect.top - containerRect.top + swiperRect.height / 2;
      var arrowHeight = 40;
      var arrowTop = swiperCenterRelative - arrowHeight / 2;
      arrows.forEach(arrow => {
        arrow.style.top = "".concat(arrowTop, "px");
        arrow.style.transform = 'none';
      });
    } else {
      arrows.forEach(arrow => {
        arrow.style.top = '';
        arrow.style.transform = '';
      });
    }
  };
  swiper.on('init', () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(syncArrowPosition);
    });
  });
  swiper.on('resize', () => {
    requestAnimationFrame(syncArrowPosition);
  });
  swiper.on('slideChange', () => {
    requestAnimationFrame(syncArrowPosition);
  });
  updateArrowVisibility(swiper, prevButton, nextButton, pagination);
});